export default "__VITE_ASSET__BKfdseEk__"